import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { PageHeader } from '@/components/layout';
import { Card, CardContent } from '@/components/ui';
import { MnoIpRangeForm } from '@/components/features/mno-ip-ranges/mno-ip-range-form';
import { useCreateMnoIpRange, useMnoOperators } from '@/hooks/use-mno-ip-ranges';
import { ApiError } from '@/lib/api/client';
import type { CreateMnoIpRangeInput } from '@/types/mno-ip-range';

export function MnoIpRangeCreatePage() {
  const { t } = useTranslation('mno-ip-ranges');
  const navigate = useNavigate();
  const { data: operators } = useMnoOperators();
  const createMutation = useCreateMnoIpRange();
  // Server-Fehler formularnah: 409 (Eintrag existiert / CIDR-Duplikat), 400/422.
  const [submitError, setSubmitError] = useState<string | null>(null);

  const handleSubmit = (input: CreateMnoIpRangeInput) => {
    setSubmitError(null);
    createMutation.mutate(input, {
      onSuccess: () => navigate('/mno-ip-ranges'),
      onError: (err) => {
        if (err instanceof ApiError && [400, 409, 422].includes(err.status)) {
          setSubmitError(err.message || t('edit.saveFailed'));
          return;
        }
        toast.error(err instanceof Error ? err.message : t('edit.saveFailed'));
      },
    });
  };

  return (
    <div>
      <PageHeader title={t('create.title')} description={t('create.description')} />
      <Card>
        <CardContent className="pt-6">
          <MnoIpRangeForm
            mode="create"
            operators={operators ?? []}
            submitting={createMutation.isPending}
            submitError={submitError}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/mno-ip-ranges')}
          />
        </CardContent>
      </Card>
    </div>
  );
}
